import { FC, useEffect, useState } from "react";
import { GBtn } from "..";
import { css } from "@emotion/react";

type Props = React.ComponentProps<typeof GBtn>;

const GBtnGradientGlow: FC<Props> = (props) => {
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);
  const [size, setSize] = useState("0");

  useEffect(() => {
    const size = props.style?.width
      ? `calc(400 / 89.46 * ${props.style?.width})`
      : "400px";

    setSize(size);
  }, []);

  const styles = css`
    position: relative;
    overflow: hidden;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    & span {
      pointer-events: none;
      position: relative;
    }

    &::before {
      content: "";
      position: absolute;
      left: ${mouseX}px;
      top: ${mouseY}px;
      width: 0;
      height: 0;
      background: radial-gradient(
        circle,
        rgba(68, 5, 247, 1) 0%,
        rgba(247, 35, 89, 1) 36%
      );
      border-radius: 1000px;
      transform: translate(-50%, -50%);
    }

    &:hover::before {
      width: ${size};
      height: ${size};
    }
  `;

  const handleMouseMove = (e: React.MouseEvent) => {
    // @ts-ignore
    const x = e.pageX - e.target.offsetLeft;
    // @ts-ignore
    const y = e.pageY - e.target.offsetTop;

    setMouseX(x);
    setMouseY(y);
  };

  return (
    <GBtn css={styles} {...props} handleMouseMove={handleMouseMove} hasChild>
      <span>{props.text}</span>
    </GBtn>
  );
};

GBtnGradientGlow.defaultProps = {
  fontColor: "#fff",
  background: "#854DFF",
};

export default GBtnGradientGlow;

/*

addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
})
*/
